import React from 'react'
import { connect } from 'react-redux';
import { CFooter } from '@coreui/react'
import moment from 'moment';
import { RootState } from '../store/state';

export interface FooterProps {
  orgID: number;
}

const TheFooter = ({ orgID }: FooterProps) => {
  return (
    <CFooter fixed={ false } className='justify-content-between'>
      <div>
        <span className="ml-3">{ moment().format('YYYY') } &copy; </span>
        <a href="https://glympse.com" target="_blank" rel="noopener noreferrer">Glympse</a>
      </div>
      { ['development', 'sandbox'].includes(process.env.NODE_ENV) && (
        <div className="mr-3">
          <a target="_blank" rel="noreferrer" href={ `https://s-admin.enterprise.glympse.com/#/org/${ orgID }` }>{ orgID }</a>
        </div>
      ) }
    </CFooter>
  )
}

const mapStateToProps = (state: RootState) => ({
  orgID: state?.profile?.userInfo?.orgId,
});

export default connect(mapStateToProps)(TheFooter);